// extracted by mini-css-extract-plugin
export default {"wrapper":"dualMenu__wrapper__WvuQq","button":"dualMenu__button__JLDSE","slide":"dualMenu__slide__QrpiD","active":"dualMenu__active__i8D7r","widget":"dualMenu__widget__Bs8dn"};